"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareMyPagesLayoutProps = void 0;
var _auth = require("@ori/auth");
var _merge = _interopRequireDefault(require("es-toolkit/compat/merge"));
var _mapAndValidateBaseUrls = require("../../utils/mapAndValidateBaseUrls");
var _MyPagesFeature = require("./MyPagesFeature");
var _internal = require("./internal");
/**
 * The function is used to constructs object with empty layout properties used by `EmptyLayout` component
 * @param props - {@link PrepareMyPagesLayoutProps}
 * @returns Object typed as {@link EmptyLayoutProps}
 */
const defaultMyPagesAppLoaders = {
  spas: {
    logoutConfirmDialog: {
      enabled: true
    },
    userSessionProvider: {
      enabled: true
    }
  },
  libs: {
    basketProvider: {
      enabled: true
    },
    errorNotification: {
      enabled: true
    },
    feedbackBenefitDialog: {
      enabled: true
    },
    miniShoppingBag: {
      enabled: true
    },
    productInfoDialog: {
      enabled: true
    },
    subscriptionWizard: {
      enabled: true
    }
  }
};
const prepareMyPagesLayoutProps = ({
  page: {
    appLoaders,
    cultureSettings,
    developmentInfo,
    environment,
    features,
    language,
    pageMetaData,
    periodCode,
    servicesUrls,
    tenant,
    token,
    useLegacyKendoCulture = false,
    useLegacyTokenService = false,
    requiredServicesUrls = [],
    enableWebVitalsCollection = false,
    enableFavorites = false,
    operationId
  },
  layout: {
    languages,
    translations,
    defaultTranslations,
    componentsProps,
    disableWidthLimit = false
  }
}) => ({
  page: {
    appLoaders: appLoaders ? (0, _merge.default)({}, appLoaders, defaultMyPagesAppLoaders) : defaultMyPagesAppLoaders,
    ...(pageMetaData && {
      pageMetaData
    }),
    ...(defaultTranslations && {
      defaultTranslations
    }),
    ...(translations && {
      translations
    }),
    cultureSettings,
    language,
    customerId: _auth.NOT_LOGGED_IN_USER_ID,
    developmentInfo,
    environment,
    features: [...features.values()],
    isProduction: process.env.NODE_ENV === 'production',
    pageBuiltAt: new Date().toString(),
    pageFeatures: _MyPagesFeature.MyPagesLayoutFeature,
    periodCode,
    servicesUrls: (0, _mapAndValidateBaseUrls.mapAndValidateBaseUrls)(servicesUrls, [..._internal.myPagesLayoutRequiredServices, ...requiredServicesUrls]),
    tenant,
    token,
    useLegacyKendoCulture,
    useLegacyTokenService,
    enableWebVitalsCollection,
    enableFavorites,
    operationId
  },
  layout: {
    ...(languages && {
      languages
    }),
    ...(componentsProps && {
      componentsProps
    }),
    disableWidthLimit
  }
});
exports.prepareMyPagesLayoutProps = prepareMyPagesLayoutProps;
